import React, { useEffect, useMemo, useState } from 'react';
import './DisbursalDetails.css';
import RefundModal from './RefundModal';
import { toast } from 'react-toastify';
import axios from 'axios';

const DisbursalDetails = ({ trancheData }) => {
  const [expandedRow, setExpandedRow] = useState(3); // Default expand the 3rd row for mockup
  const [isRefundModalOpen, setIsRefundModalOpen] = useState(false);
  const [selectedExcessDetails, setSelectedExcessDetails] = useState(null);

  const [financialSummary, setFinancialSummary] = useState(null);

  const tokens = JSON.parse(sessionStorage.getItem("tokens")) || null;
  const authToken = tokens?.token || null;

  const getTrancheFinancialSummary = async () => {
    if (!trancheData?.tranche_id) return;

    let headers = {
      'Content-type': 'application/json',
      'Authorization': `Bearer ${authToken}`
    };

    try {
      let response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/tranche/${trancheData?.tranche_id}/financial-summary`, { headers });

      setFinancialSummary(response?.data?.data);
    }
    catch (error) {
      toast.error(`${error?.response?.data?.message}`);
    }
  }

  useEffect(() => {
    if (trancheData?.tranche_id) {
      getTrancheFinancialSummary();
    }
  }, [trancheData?.tranche_id]);

  const toggleRow = (id) => {
    setExpandedRow(expandedRow === id ? null : id);
  };

  const financialSummaryStats = useMemo(() => {
    return [
      { label: "Total disbursed", value: financialSummary?.financial_summary?.total_tranche_amount || 0 },
      { label: "Total repaid", value: financialSummary?.financial_summary?.total_payment_received || 0, color: "#1E8E3E" },
      { label: "Outstanding", value: financialSummary?.financial_summary?.total_outstanding || 0 },
      { label: "Total interest paid", value: financialSummary?.financial_summary?.total_interest_paid || 0 },
      { label: "Total Late Charges paid", value: financialSummary?.financial_summary?.total_late_charges_paid || 0 },
      { label: "Interest Till Date", value: financialSummary?.financial_summary?.interest_till_date || 0 },
      { label: "Till Date Outstanding", value: financialSummary?.financial_summary?.till_day_outstanding || 0 }
    ]
  }, [financialSummary?.financial_summary]);

  const excessManagementDetails = financialSummary?.excess_management_details;
  const paymentAllocationDetails = financialSummary?.payment_allocation;
  const financialSummaryDetails = financialSummary?.financial_summary;
  
  console.log({ paymentAllocationDetails});

  return (
    <div className="disbursal-details-container">
      {/* Summary Section */}
      <div className="disbursal-summary">
        {financialSummaryStats?.map((stat, index) => (
          <div className="summary-item" key={index}>
            <span className="summary-label">{stat.label}</span>
            <span className="summary-value" style={stat.color ? { color: stat.color } : {}}>
              {
                new Intl.NumberFormat("en-IN", {
                  style: "currency",
                  currency: "INR",
                }).format(stat.value)
              }
            </span>
          </div>
        ))}
      </div>

      {/* Table Section */}
      <div className="allocation-header">
        <div className="allocation-title">
          EMI allocation breakdown
          {/* <span className="allocation-subtitle">Click to expand payment split</span> */}
        </div>
      </div>

      <div className="allocation-table-container">
        <table className="allocation-table">
          <thead>
            <tr>
              <th>EMI #</th>
              <th>Payment date</th>
              <th>EMI amount</th>
              <th>Paid</th>
              <th>Principal adj.</th>
              <th>Interest adj.</th>
              <th>Balance principal</th>
              <th>Late Fee Due</th>
              <th>Late Fee Adjusted</th>
              <th>Status</th>
              <th>Excess</th>
              <th>Current Excess</th>
            </tr>
          </thead>
          <tbody>
            {/* {emiData.map((row) => ( */}
            {paymentAllocationDetails?.map((row) => (
              <React.Fragment key={row.id}>
                <tr 
                  // onClick={() => toggleRow(row.id)}
                >
                  <td>{row.payment_id}</td>
                  <td>{row.payment_date?.split('T')?.[0]}</td>
                  <td>{row.tranche_emi_amount}</td>
                  <td>{row.payment_amount}</td>
                  <td>{row.adjusted_principal}</td>
                  <td>{row.adjusted_interest}</td>
                  <td>{row.remaining_principal}</td>
                  <td>{row.late_fee_due}</td>
                  <td>{row.late_fee_adjusted}</td>
                  <td>
                    <span className={`leadStatusBadge status-${row.payment_status?.toLowerCase()?.replace('_', '-')}`}>
                      <span className="statusDot"></span>
                      {row.payment_status?.split('_').join(" ")}
                    </span>
                  </td>
                  <td className={row.excess_amount !== 0 ? 'excess-value' : ''}>{row.excess_amount}</td>
                  <td className={row.excess_amount !== 0 ? 'excess-value' : ''}>{row.pending_excess_amount}</td>
                </tr>
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>

      {/* Expandable Excess Alert Box */}
      {
        (Number(financialSummaryDetails?.pending_excess_amount) > 0) && 
        (
          <div className="excess-alert-box">
            <div className="excess-alert-header">
              <span className="excess-alert-title">Excess amount detected</span>
              <button
                className="approval-button"
                onClick={(e) => {
                  e.stopPropagation();
                  if(excessManagementDetails?.[0]?.is_approved){
                    setSelectedExcessDetails(excessManagementDetails?.[0]);
                    setIsRefundModalOpen(true);
                  }
                }}
                disabled={!excessManagementDetails?.[0]?.is_approved}
              >
                {excessManagementDetails?.[0]?.is_approved ? "Refund approved" : "Refund pending approval"}
              </button>
            </div>

            <div className="excess-alert-details">
              <div className="detail-item">
                <span className="detail-label">Excess amount</span>
               <span className="detail-value excess-value">{excessManagementDetails?.[0]?.excess_amount || financialSummaryDetails?.pending_excess_amount}</span>
              </div>
              {/* <div className="detail-item">
                <span className="detail-label">Source payment UTR</span>
                <span className="detail-value">{excessManagementDetails?.[0]?.excess_amount}</span>
              </div> */}
              {/* <div className="detail-item">
                <span className="detail-label">Payment date</span>
                <span className="detail-value">{excessManagementDetails?.[0]?.excess_amount}</span>
              </div> */}
              <div className="detail-item">
                <span className="detail-label">QMS task</span>
                <span className="detail-value link">{excessManagementDetails?.[0]?.readable_task_id || excessManagementDetails?.[0]?.task_id}</span>
              </div>
            </div>

            <div className="excess-alert-footer">
              <span
                className="footer-text"
                style={{ 
                  cursor: excessManagementDetails?.[0]?.is_approved ? 'pointer' : 'not-allowed', 
                  color: excessManagementDetails?.[0]?.is_approved ? '#185FA5' : 'gray', 
                  textDecoration: 'underline' 
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  if(excessManagementDetails?.[0]?.is_approved){
                    setSelectedExcessDetails(excessManagementDetails?.[0]);
                    setIsRefundModalOpen(true);
                  }
                }}
              >
                {excessManagementDetails?.[0]?.is_approved ? "Refund approved" : "Refund pending approval"}
              </span>
              <span className="footer-subtext">
                {excessManagementDetails?.[0]?.is_approved ? "" : `Awaiting QMS approver action on task ${excessManagementDetails?.[0]?.readable_sub_task_id || excessManagementDetails?.[0]?.sub_task_id || excessManagementDetails?.[0]?.readable_task_id}`}
              </span>
            </div>
          </div>
        )
      }

      <RefundModal
        isOpen={isRefundModalOpen}
        onClose={() => setIsRefundModalOpen(false)}
        excessDetails={selectedExcessDetails}
        financialSummaryDetails={financialSummaryDetails}
        getTrancheFinancialSummary={getTrancheFinancialSummary}
      />
    </div>
  );
}

export default DisbursalDetails;